// Auto-generated build marker. Update this on significant releases to force
// fresh bundle hashing and aid in identifying which build is deployed.
export const BUILD_VERSION = "1.7.0-mentor-engine";
export const BUILD_DATE = "2026-04-30";
export const BUILD_NOTES = "Homiletics Mentor engine (backend) — 8 expressions, 6 tones, 3 coaching modes, safety-hardened";
